export type AttendApiContract = "v1" | "v2"

const configuredContract = import.meta.env.VITE_ATTENDVIP_API_CONTRACT

export const ATTEND_API_CONTRACT: AttendApiContract =
  configuredContract === "v2" ? "v2" : "v1"

export const isV2Api = ATTEND_API_CONTRACT === "v2"

export function authApiPathForContract(
  contract: AttendApiContract,
  path: string,
): string {
  if (path === "") return `/auth/${contract}`
  const suffix = path.startsWith("/") ? path : `/${path}`
  return `/auth/${contract}${suffix}`
}

export function authApiPath(path: string): string {
  return authApiPathForContract(ATTEND_API_CONTRACT, path)
}

export function tokenApiPathForContract(contract: AttendApiContract): string {
  return `/api/${contract}/token`
}

export function tokenApiPath(): string {
  return tokenApiPathForContract(ATTEND_API_CONTRACT)
}
